var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 64a1.5 1.5 0 01-1.06-2.56l61-61a1.5 1.5 0 012.12 2.12l-61 61A1.5 1.5 0 011.5 64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 64a1.5 1.5 0 01-1.06-.44l-61-61A1.5 1.5 0 012.56.44l61 61A1.5 1.5 0 0162.5 64z"
  })));
}
export default SvgClose;